function l() {
  return {
    before: function before(_ref) {
      var e = _ref.doc,
          o = _ref.d;
      o.style(e.documentElement, "overflow", "hidden");
    }
  };
}

export { l as preventScroll };